module.exports = __webpack_public_path__ + "static/media/calls.a4c3432d.png";